export default "__VITE_ASSET__CC6N_wM7__"